export default __webpack_public_path__ + "static/media/ransomewareRealcase.1048828c.png";